<template>
    <main>
        <section>
            <div class="content-960">
                <div class="row">
                    <section class="col-sm-6">
                        <ul class="breadcrumb">
                            <li><a href="/home" title="Home">CNA Box</a></li>
                            <li><a href="/estagio" title="Estagio">Estagio</a></li>
                            <li>Importacao/Exportacao</li>
                        </ul>
                    </section>
                    <section class="col-sm-6">
                        <button class="btn-large-40 btn-default uppercase pull-right btn-header" @click="voltar()">
                            Voltar
                        </button>
                    </section>
                </div>
            </div>

            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="titles icons icon-news-middle">
                        <h2 class="uppercase"><b>Importacao/Exportacao Excel - Estagio {{ estagioId }}</b></h2>
                    </div>

                    <b-tabs v-model="abaAtiva">

                        <!-- ABA 1: PLANILHA -->
                        <b-tab title="1. Planilha">
                            <br />
                            <div class="card">
                                <div class="card-body">
                                    <h5 class="card-title">Exportar Planilha Modelo</h5>
                                    <p class="card-text">
                                        Baixe a planilha com os dados atuais de Conteudos e Avaliacoes deste estagio.
                                        Edite os dados e envie de volta para importacao.
                                    </p>
                                    <button class="btn btn-success" @click="downloadTemplate()" :disabled="downloading">
                                        <i class="fa fa-download"></i> Baixar Planilha Modelo
                                    </button>
                                </div>
                            </div>

                            <hr />

                            <div class="card">
                                <div class="card-body">
                                    <h5 class="card-title">Importar Planilha</h5>
                                    <p class="card-text">
                                        Selecione o arquivo Excel (.xlsx) editado para validacao.
                                    </p>
                                    <div class="form-group">
                                        <input type="file" class="form-control-file" accept=".xlsx"
                                            @change="handleFileChange($event)" ref="fileInput" />
                                    </div>
                                    <button class="btn btn-primary" @click="uploadParaValidacao()"
                                        :disabled="!arquivo || validando">
                                        <i class="fa fa-upload"></i>
                                        {{ validando ? 'Validando...' : 'Enviar para Validacao' }}
                                    </button>
                                </div>
                            </div>
                        </b-tab>

                        <!-- ABA 2: VALIDACAO -->
                        <b-tab title="2. Validacao" :disabled="!previewCarregado">
                            <br />
                            <div v-if="preview">
                                <!-- Resumo -->
                                <div class="mb-3">
                                    <span class="badge badge-success mr-2">{{ preview.totalInsercoes }} insercoes</span>
                                    <span class="badge badge-warning mr-2">{{ preview.totalAtualizacoes }} atualizacoes</span>
                                    <span class="badge badge-secondary mr-2">{{ preview.totalSemAlteracao }} sem alteracao</span>
                                    <span class="badge badge-danger mr-2">{{ preview.totalErros }} erros</span>
                                    <label class="ml-3" style="font-weight: normal; cursor: pointer;">
                                        <input type="checkbox" v-model="ocultarSemAlteracao" /> Exibir apenas alterados e novos
                                    </label>
                                </div>

                                <!-- Erros gerais -->
                                <div v-if="preview.errosGerais && preview.errosGerais.length > 0"
                                    class="alert alert-danger">
                                    <strong>Erros gerais:</strong>
                                    <ul class="mb-0">
                                        <li v-for="(erro, i) in preview.errosGerais" :key="'eg'+i">{{ erro }}</li>
                                    </ul>
                                </div>

                                <!-- Tabela CONTEUDOS -->
                                <h5 v-if="conteudosFiltrados.length > 0">Conteudos</h5>
                                <div v-if="conteudosFiltrados.length > 0"
                                    class="table-responsive standard-table header-cinza mb-4">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th style="width: 90px;">Status</th>
                                                <th v-for="col in colunasConteudo" :key="col.key">{{ col.label }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-for="linha in conteudosFiltrados">
                                                <!-- Linha unica: Insercao, Sem alteracao, Erro -->
                                                <tr v-if="linha.tipoOperacao !== 'Atualizacao'"
                                                    :key="'c'+linha.linhaExcel"
                                                    :class="getStatusClass(linha)">
                                                    <td>
                                                        <span class="badge" :class="getStatusBadgeClass(linha)">
                                                            {{ linha.tipoOperacao }}
                                                        </span>
                                                    </td>
                                                    <td v-for="col in colunasConteudo" :key="col.key">
                                                        {{ linha.dados && linha.dados[col.key] }}
                                                    </td>
                                                </tr>
                                                <!-- Atualizacao: linha original -->
                                                <tr v-if="linha.tipoOperacao === 'Atualizacao'"
                                                    :key="'co'+linha.linhaExcel"
                                                    class="row-original">
                                                    <td rowspan="2" style="vertical-align: middle;">
                                                        <span class="badge badge-warning">Atualizacao</span>
                                                    </td>
                                                    <td v-for="col in colunasConteudo" :key="col.key"
                                                        :class="{ 'celula-antes': isFieldChanged(linha, col.key) }">
                                                        {{ getOriginalValue(linha, col.key) }}
                                                    </td>
                                                </tr>
                                                <!-- Atualizacao: linha nova -->
                                                <tr v-if="linha.tipoOperacao === 'Atualizacao'"
                                                    :key="'cn'+linha.linhaExcel"
                                                    class="row-novo">
                                                    <td v-for="col in colunasConteudo" :key="col.key"
                                                        :class="{ 'celula-depois': isFieldChanged(linha, col.key) }">
                                                        {{ linha.dados && linha.dados[col.key] }}
                                                    </td>
                                                </tr>
                                                <!-- Erros -->
                                                <tr v-if="linha.erros && linha.erros.length > 0"
                                                    :key="'ce'+linha.linhaExcel"
                                                    class="table-danger">
                                                    <td :colspan="colunasConteudo.length + 1">
                                                        <ul class="text-danger mb-0" style="padding-left: 15px;">
                                                            <li v-for="(e, ei) in linha.erros" :key="ei">{{ e }}</li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>

                                <!-- Tabela AVALIACOES -->
                                <h5 v-if="avaliacoesFiltradas.length > 0">Avaliacoes</h5>
                                <div v-if="avaliacoesFiltradas.length > 0"
                                    class="table-responsive standard-table header-cinza mb-4">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th style="width: 90px;">Status</th>
                                                <th v-for="col in colunasAvaliacao" :key="col.key">{{ col.label }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-for="linha in avaliacoesFiltradas">
                                                <tr v-if="linha.tipoOperacao !== 'Atualizacao'"
                                                    :key="'a'+linha.linhaExcel"
                                                    :class="getStatusClass(linha)">
                                                    <td>
                                                        <span class="badge" :class="getStatusBadgeClass(linha)">
                                                            {{ linha.tipoOperacao }}
                                                        </span>
                                                    </td>
                                                    <td v-for="col in colunasAvaliacao" :key="col.key">
                                                        {{ linha.dados && linha.dados[col.key] }}
                                                    </td>
                                                </tr>
                                                <tr v-if="linha.tipoOperacao === 'Atualizacao'"
                                                    :key="'ao'+linha.linhaExcel"
                                                    class="row-original">
                                                    <td rowspan="2" style="vertical-align: middle;">
                                                        <span class="badge badge-warning">Atualizacao</span>
                                                    </td>
                                                    <td v-for="col in colunasAvaliacao" :key="col.key"
                                                        :class="{ 'celula-antes': isFieldChanged(linha, col.key) }">
                                                        {{ getOriginalValue(linha, col.key) }}
                                                    </td>
                                                </tr>
                                                <tr v-if="linha.tipoOperacao === 'Atualizacao'"
                                                    :key="'an'+linha.linhaExcel"
                                                    class="row-novo">
                                                    <td v-for="col in colunasAvaliacao" :key="col.key"
                                                        :class="{ 'celula-depois': isFieldChanged(linha, col.key) }">
                                                        {{ linha.dados && linha.dados[col.key] }}
                                                    </td>
                                                </tr>
                                                <tr v-if="linha.erros && linha.erros.length > 0"
                                                    :key="'ae'+linha.linhaExcel"
                                                    class="table-danger">
                                                    <td :colspan="colunasAvaliacao.length + 1">
                                                        <ul class="text-danger mb-0" style="padding-left: 15px;">
                                                            <li v-for="(e, ei) in linha.erros" :key="ei">{{ e }}</li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>

                                <!-- Botoes -->
                                <div class="mt-3">
                                    <button class="btn btn-success" @click="abaAtiva = 2"
                                        :disabled="!preview.ehValido">
                                        Confirmar Alteracoes
                                    </button>
                                    <button class="btn btn-default ml-2" @click="abaAtiva = 0">
                                        Voltar
                                    </button>
                                </div>
                            </div>
                        </b-tab>

                        <!-- ABA 3: CONFIRMAR -->
                        <b-tab title="3. Confirmar" :disabled="!previewValido">
                            <br />
                            <div v-if="preview">
                                <div class="card">
                                    <div class="card-body">
                                        <h5 class="card-title">Resumo da Importacao</h5>
                                        <p>
                                            <span class="badge badge-success mr-2">{{ preview.totalInsercoes }} insercoes</span>
                                            <span class="badge badge-warning mr-2">{{ preview.totalAtualizacoes }} atualizacoes</span>
                                        </p>
                                        <div class="alert alert-warning">
                                            <strong>Atencao!</strong> Esta acao ira modificar os dados de Conteudos e
                                            Avaliacoes deste estagio. Esta operacao nao pode ser desfeita automaticamente.
                                        </div>
                                        <button class="btn btn-danger" @click="confirmarImportacao()"
                                            :disabled="aplicando">
                                            <i class="fa fa-check"></i>
                                            {{ aplicando ? 'Aplicando...' : 'Aplicar Importacao' }}
                                        </button>
                                        <button class="btn btn-default ml-2" @click="abaAtiva = 0"
                                            :disabled="aplicando">
                                            Cancelar
                                        </button>
                                    </div>
                                </div>

                                <!-- Resultado -->
                                <div v-if="resultado" class="mt-3">
                                    <div v-if="resultado.sucesso" class="alert alert-success">
                                        <strong>Importacao realizada com sucesso!</strong><br />
                                        {{ resultado.totalInsercoes }} insercoes e {{ resultado.totalAtualizacoes }} atualizacoes aplicadas.
                                    </div>
                                    <div v-else class="alert alert-danger">
                                        <strong>Erro na importacao:</strong>
                                        <ul class="mb-0">
                                            <li v-for="(e, i) in resultado.erros" :key="i">{{ e }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </b-tab>

                        <!-- ABA 4: HISTORICO -->
                        <b-tab title="Historico">
                            <br />
                            <div v-if="historico.items.length === 0" class="alert alert-info">
                                Nenhum historico de importacao encontrado para este estagio.
                            </div>
                            <div v-else>
                                <div v-for="lote in historico.items" :key="lote.loteImportacao" class="card mb-3">
                                    <div class="card-header" style="cursor: pointer;"
                                        @click="toggleLote(lote.loteImportacao)">
                                        <strong>{{ formatDate(lote.dataImportacao) }}</strong>
                                        <span class="ml-3 badge badge-success">{{ lote.totalInsercoes }} insercoes</span>
                                        <span class="ml-1 badge badge-warning">{{ lote.totalAtualizacoes }} atualizacoes</span>
                                        <span class="ml-1 badge badge-secondary">{{ lote.totalRegistros }} registros</span>
                                        <i class="fa pull-right" :class="loteAberto === lote.loteImportacao ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                    </div>
                                    <div class="card-body" v-if="loteAberto === lote.loteImportacao">
                                        <div class="table-responsive">
                                            <table class="table table-sm table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Tipo Entidade</th>
                                                        <th>ID Entidade</th>
                                                        <th>Operacao</th>
                                                        <th>Campo</th>
                                                        <th>Valor Anterior</th>
                                                        <th>Valor Novo</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(det, di) in lote.detalhes" :key="di">
                                                        <td>{{ det.tipoEntidade }}</td>
                                                        <td>{{ det.entidadeId }}</td>
                                                        <td>{{ det.tipoOperacao }}</td>
                                                        <td>{{ det.campo }}</td>
                                                        <td>{{ det.valorAnterior }}</td>
                                                        <td>{{ det.valorNovo }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                <!-- Paginacao -->
                                <div class="text-center" v-if="historico.total > historicoFilter.pageSize">
                                    <button class="btn btn-sm btn-default mr-2"
                                        :disabled="historicoFilter.pageIndex <= 1"
                                        @click="historicoFilter.pageIndex--; carregarHistorico()">
                                        Anterior
                                    </button>
                                    <span>Pagina {{ historicoFilter.pageIndex }} de {{ Math.ceil(historico.total / historicoFilter.pageSize) }}</span>
                                    <button class="btn btn-sm btn-default ml-2"
                                        :disabled="historicoFilter.pageIndex >= Math.ceil(historico.total / historicoFilter.pageSize)"
                                        @click="historicoFilter.pageIndex++; carregarHistorico()">
                                        Proximo
                                    </button>
                                </div>
                            </div>
                        </b-tab>

                    </b-tabs>
                </div>
            </div>
        </section>
    </main>
</template>

<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'
    import Cache from '@/common/cache.js'
    import Global from '@/common/global.js'
    import axios from 'axios'

    export default {
        name: 'EstagioImportacao',
        mixins: [base],
        data() {
            return {
                estagioId: null,
                abaAtiva: 0,
                arquivo: null,
                preview: null,
                previewCarregado: false,
                previewValido: false,
                resultado: null,
                downloading: false,
                validando: false,
                aplicando: false,
                historico: { items: [], total: 0 },
                historicoFilter: { pageIndex: 1, pageSize: 10 },
                loteAberto: null,
                ocultarSemAlteracao: true,
                colunasConteudo: [
                    { key: 'id', label: 'ID' },
                    { key: 'conteudo', label: 'Conteudo' },
                    { key: 'tempo', label: 'Tempo' },
                    { key: 'ordem', label: 'Ordem' },
                    { key: 'ehAvaliacao', label: 'Avaliacao' },
                    { key: 'ehAssincrona', label: 'Assincrona' },
                    { key: 'eAdicional', label: 'Adicional' }
                ],
                colunasAvaliacao: [
                    { key: 'id', label: 'ID' },
                    { key: 'nome', label: 'Nome' },
                    { key: 'nomeTraduzido', label: 'Nome Trad.' },
                    { key: 'unidade', label: 'Unidade' },
                    { key: 'tipoAvaliacaoId', label: 'Tipo Aval.' },
                    { key: 'pontuacao', label: 'Pontuacao' },
                    { key: 'ordem', label: 'Ordem' },
                    { key: 'externalId', label: 'External ID' },
                    { key: 'ignoraPontuacaoPadrao', label: 'Ignora Pont.' },
                    { key: 'salaAula', label: 'Sala Aula' },
                    { key: 'meioCurso', label: 'Meio Curso' },
                    { key: 'excluido', label: 'Excluido' }
                ]
            }
        },
        computed: {
            conteudosFiltrados: function () {
                if (!this.preview || !this.preview.conteudos) return [];
                if (this.ocultarSemAlteracao) {
                    return this.preview.conteudos.filter(function (l) { return l.tipoOperacao !== 'Sem alteracao'; });
                }
                return this.preview.conteudos;
            },
            avaliacoesFiltradas: function () {
                if (!this.preview || !this.preview.avaliacoes) return [];
                if (this.ocultarSemAlteracao) {
                    return this.preview.avaliacoes.filter(function (l) { return l.tipoOperacao !== 'Sem alteracao'; });
                }
                return this.preview.avaliacoes;
            }
        },
        methods: {
            voltar: function () {
                this.$router.push({ path: '/estagio' });
            },

            downloadTemplate: function () {
                this.downloading = true;
                var accesstoken = Cache.get(Global.ACCESS_TOKEN);
                axios.get(Global.END_POINT_DEFAULT + '/estagioimportacao/ExportTemplate/' + this.estagioId, {
                    responseType: 'blob',
                    headers: {
                        'Authorization': 'Bearer ' + accesstoken
                    }
                }).then(function (response) {
                    var blob = new Blob([response.data], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    });
                    var _a = document.createElement("a");
                    document.body.appendChild(_a);
                    _a.style.visibility = 'hidden';
                    _a.target = "_blank";
                    _a.href = window.URL.createObjectURL(blob);
                    _a.download = "estagio_" + this.estagioId + "_importacao.xlsx";
                    _a.click();
                    _a.remove();
                    this.downloading = false;
                }.bind(this)).catch(function (err) {
                    this.downloading = false;
                    this.defaultErrorResult(err);
                }.bind(this));
            },

            handleFileChange: function (event) {
                this.arquivo = event.target.files[0];
                this.previewCarregado = false;
                this.previewValido = false;
                this.preview = null;
                this.resultado = null;
            },

            uploadParaValidacao: function () {
                if (!this.arquivo) return;
                this.validando = true;

                var formData = new FormData();
                formData.append('file', this.arquivo);

                var accesstoken = Cache.get(Global.ACCESS_TOKEN);
                axios.post(Global.END_POINT_DEFAULT + '/estagioimportacao/ValidarImportacao/' + this.estagioId, formData, {
                    headers: {
                        'Authorization': 'Bearer ' + accesstoken,
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(function (response) {
                    this.preview = response.data;
                    this.previewCarregado = true;
                    this.previewValido = this.preview.ehValido;
                    this.validando = false;
                    this.$nextTick(function () {
                        this.abaAtiva = 1;
                    }.bind(this));
                }.bind(this)).catch(function (err) {
                    this.validando = false;
                    this.defaultErrorResult(err);
                }.bind(this));
            },

            confirmarImportacao: function () {
                if (!this.arquivo) return;
                this.aplicando = true;

                var formData = new FormData();
                formData.append('file', this.arquivo);

                var accesstoken = Cache.get(Global.ACCESS_TOKEN);
                axios.post(Global.END_POINT_DEFAULT + '/estagioimportacao/AplicarImportacao/' + this.estagioId, formData, {
                    headers: {
                        'Authorization': 'Bearer ' + accesstoken,
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(function (response) {
                    this.resultado = response.data;
                    this.aplicando = false;
                    if (this.resultado.sucesso) {
                        this.defaultSuccessResult("Importacao realizada com sucesso!");
                        this.carregarHistorico();
                    }
                }.bind(this)).catch(function (err) {
                    this.aplicando = false;
                    this.defaultErrorResult(err);
                }.bind(this));
            },

            carregarHistorico: function () {
                var accesstoken = Cache.get(Global.ACCESS_TOKEN);
                axios.get(Global.END_POINT_DEFAULT + '/estagioimportacao/Historico/' + this.estagioId, {
                    params: this.historicoFilter,
                    headers: {
                        'Authorization': 'Bearer ' + accesstoken
                    }
                }).then(function (response) {
                    this.historico = response.data;
                }.bind(this)).catch(function () {
                    // silencioso - historico nao e critico
                }.bind(this));
            },

            getStatusClass: function (linha) {
                if (!linha.ehValido) return 'table-danger';
                if (linha.tipoOperacao === 'Insercao') return 'table-success';
                if (linha.tipoOperacao === 'Atualizacao') return 'table-warning';
                return '';
            },

            getStatusBadgeClass: function (linha) {
                if (!linha.ehValido) return 'badge-danger';
                if (linha.tipoOperacao === 'Insercao') return 'badge-success';
                if (linha.tipoOperacao === 'Atualizacao') return 'badge-warning';
                return 'badge-secondary';
            },

            isFieldChanged: function (linha, campo) {
                if (!linha.camposAlterados) return false;
                var campoLower = campo.toLowerCase();
                return linha.camposAlterados.some(function (ca) { return ca.campo.toLowerCase() === campoLower; });
            },

            getOriginalValue: function (linha, campo) {
                if (!linha.camposAlterados) return linha.dados && linha.dados[campo];
                var campoLower = campo.toLowerCase();
                var alterado = linha.camposAlterados.find(function (ca) { return ca.campo.toLowerCase() === campoLower; });
                if (alterado) return alterado.valorAnterior;
                return linha.dados && linha.dados[campo];
            },

            toggleLote: function (loteId) {
                this.loteAberto = this.loteAberto === loteId ? null : loteId;
            },

            formatDate: function (dateStr) {
                if (!dateStr) return '';
                var d = new Date(dateStr);
                return d.toLocaleDateString('pt-BR') + ' ' + d.toLocaleTimeString('pt-BR');
            }
        },

        mounted() {
            this.estagioId = this.$route.params.id;
            this.carregarHistorico();
        }
    };
</script>

<style scoped>
.row-original td {
    border-bottom: none !important;
}
.row-novo td {
    border-top: none !important;
}
.row-novo {
    border-bottom: 2px solid #dee2e6;
}
.celula-antes {
    background-color: #ffeef0 !important;
    text-decoration: line-through;
    color: #cb2431;
}
.celula-depois {
    background-color: #e6ffed !important;
    font-weight: bold;
    color: #22863a;
}
</style>
